import { Box, Grid2, Typography } from '@mui/material'
import React from 'react'
import Heading from '../../shared/utils/Heading'
import { EducationForLifeImages } from '../../assets/img/educationforlife/EducationForLifeImages'
import useResponsive from '../../shared/utils/Responsive'
import { getImageUrl } from '../../shared/utils/getImageUrl'

const ElyfDefferenceSection = ({differenceElyfData}) => {
      const isSmallScreen = useResponsive("sm")
    return (
        <Box>
            <Heading Heading={differenceElyfData?.heading} center />
            <Grid2 container>
             
             
             {/* {!isSmallScreen &&   <Grid2 container size={12}>
                    <Grid2 children size={4}

                    >
                        <Typography variant='body2' sx={{
                            width: {xs:"100%",sm:"80%",md:"50%"}, position: "relative", ml: "auto",
                            transform: "translateY(80px)"
                        }} textAlign={"end"}


                        >
                            Children learn to think, solve, read, and write independently without depending on parents for every concept
                        </Typography>
                    </Grid2>
                    <Grid2 children size={4}>
                        <Typography variant='body2' sx={{ width: {xs:"100%",sm:"80%",md:"50%"}, position: "relative", mx: "auto" }} textAlign={"center"}>
                            When children understand the basics, they feel confident in school, participate more, and perform better
                        </Typography>
                    </Grid2>
                    <Grid2 children size={4} textAlign={"start"}>
                        <Typography variant='body2' sx={{
                            width: {xs:"100%",sm:"80%",md:"50%"}, position: "relative", mr: "auto",


                            transform: "translateY(80px)"
                        }}>
                            Strong fundamentals automatically result in better scores in classwork, homework, tests, and exams
                        </Typography>
                    </Grid2>

                </Grid2>} */}
              
                <Grid2 container size={12}>
                    {/* <Grid2 children size={{xs:0,sm:2.5,md:12}}/> */}
                    <Grid2 children size={12}>
                        <Box
                            component={"img"}
                            // src={isSmallScreen ?EducationForLifeImages.ElyfDifferenceChartWithContent: EducationForLifeImages.ElyfDifferenceChart}
                            // src={EducationForLifeImages.ElyfDifferenceChartWithContent}
                            src={getImageUrl(differenceElyfData?.imageUrl)}
                            sx={{ width: "100%", }}

                        />
                    </Grid2>
                    {/* <Grid2 children size={{xs:0,sm:2.5,md:3.5}} /> */}

                </Grid2>
                {/* {
                    !isSmallScreen &&  <Grid2 container size={12}>
                    <Grid2 children size={4}>
                        <Typography variant='body2' sx={{
                            width:{xs:"100%",sm:"80%",md:"50%"},
                            position: "relative",
                            ml: "auto",
                            transform: "translateY(-80px)"
                        }} textAlign={"end"}>
                            Beyond academics, the curriculum builds communication skills, behaviour, confidence, and life skills
                        </Typography>
                    </Grid2>
                    <Grid2 children size={4}>
                        <Typography variant='body2' sx={{ width: {xs:"100%",sm:"80%",md:"50%"}, position: "relative", mx: "auto" }} textAlign={"center"}>
                            Children progress steadily with structured practice instead of last-minute studying.
                        </Typography>
                    </Grid2>
                    <Grid2 children size={4} textAlign={"start"}>
                        <Typography variant='body2'
                            sx={{
                                width:{xs:"100%",sm:"80%",md:"50%"},
                                position: "relative",
                                mr: "auto",
                                transform: "translateY(-80px)"
                            }}

                        >
                            Subjects like math and reading become easy and enjoyable instead of stressful
                        </Typography>
                    </Grid2>
                </Grid2>
                } */}
               

            </Grid2>


        </Box>
    )
}

export default ElyfDefferenceSection
